// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-panel {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  background: #f8f9fa;
  min-height: 100vh;
}

.admin-panel.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #666;
}

.admin-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding: 20px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.admin-header h2 {
  margin: 0;
  color: #2c3e50;
  font-size: 28px;
}

.admin-actions {
  display: flex;
  gap: 15px;
}

.save-button, .reset-button {
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.save-button {
  background: #27ae60;
  color: white;
}

.save-button:hover:not(:disabled) {
  background: #219a52;
  transform: translateY(-1px);
}

.reset-button {
  background: #e74c3c;
  color: white;
}

.reset-button:hover:not(:disabled) {
  background: #c0392b;
  transform: translateY(-1px);
}

.save-button:disabled, .reset-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.admin-message {
  padding: 15px;
  margin-bottom: 20px;
  border-radius: 8px;
  font-weight: 500;
  text-align: center;
}

.admin-message.success {
  background: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.admin-message.error {
  background: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.admin-content {
  display: flex;
  gap: 30px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  overflow: hidden;
}

.admin-sidebar {
  width: 250px;
  background: #34495e;
  padding: 0;
}

.section-button {
  width: 100%;
  padding: 20px;
  border: none;
  background: transparent;
  color: #ecf0f1;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
  border-bottom: 1px solid #2c3e50;
}

.section-button:hover {
  background: #3c5a78;
}

.section-button.active {
  background: #3498db;
  color: white;
}

.admin-main {
  flex: 1 1;
  padding: 30px;
}

.config-section {
  max-width: 600px;
}

.config-section h3 {
  margin: 0 0 30px 0;
  color: #2c3e50;
  font-size: 24px;
  border-bottom: 2px solid #3498db;
  padding-bottom: 10px;
}

.config-group {
  margin-bottom: 25px;
}

.config-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #2c3e50;
  font-size: 14px;
}

.config-group input[type="number"] {
  width: 100%;
  padding: 12px;
  border: 2px solid #ddd;
  border-radius: 6px;
  font-size: 16px;
  transition: border-color 0.2s ease;
}

.config-group input[type="number"]:focus {
  outline: none;
  border-color: #3498db;
}

.checkbox-group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.checkbox-group label {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 0;
  cursor: pointer;
}

.checkbox-group input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.config-help {
  display: block;
  margin-top: 5px;
  font-size: 12px;
  color: #7f8c8d;
  font-style: italic;
}

/* Responsive Design */
@media (max-width: 768px) {
  .admin-panel {
    padding: 10px;
  }
  
  .admin-header {
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }
  
  .admin-content {
    flex-direction: column;
  }
  
  .admin-sidebar {
    width: 100%;
    display: flex;
    overflow-x: auto;
  }
  
  .section-button {
    white-space: nowrap;
    min-width: 180px;
  }
  
  .admin-main {
    padding: 20px;
  }
  
  .config-section {
    max-width: 100%;
  }
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.config-section {
  animation: fadeIn 0.3s ease;
}

/* Custom number input styling */
.config-group input[type="number"]::-webkit-outer-spin-button,
.config-group input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.config-group input[type="number"] {
  -moz-appearance: textfield;
}`, "",{"version":3,"sources":["webpack://./src/components/AdminPanel.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,SAAO;EACP,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,gCAAgC;AAChC;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".admin-panel {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n  background: #f8f9fa;\n  min-height: 100vh;\n}\n\n.admin-panel.loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  color: #666;\n}\n\n.admin-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n  padding: 20px;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n}\n\n.admin-header h2 {\n  margin: 0;\n  color: #2c3e50;\n  font-size: 28px;\n}\n\n.admin-actions {\n  display: flex;\n  gap: 15px;\n}\n\n.save-button, .reset-button {\n  padding: 12px 24px;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.save-button {\n  background: #27ae60;\n  color: white;\n}\n\n.save-button:hover:not(:disabled) {\n  background: #219a52;\n  transform: translateY(-1px);\n}\n\n.reset-button {\n  background: #e74c3c;\n  color: white;\n}\n\n.reset-button:hover:not(:disabled) {\n  background: #c0392b;\n  transform: translateY(-1px);\n}\n\n.save-button:disabled, .reset-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.admin-message {\n  padding: 15px;\n  margin-bottom: 20px;\n  border-radius: 8px;\n  font-weight: 500;\n  text-align: center;\n}\n\n.admin-message.success {\n  background: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n}\n\n.admin-message.error {\n  background: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n}\n\n.admin-content {\n  display: flex;\n  gap: 30px;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  overflow: hidden;\n}\n\n.admin-sidebar {\n  width: 250px;\n  background: #34495e;\n  padding: 0;\n}\n\n.section-button {\n  width: 100%;\n  padding: 20px;\n  border: none;\n  background: transparent;\n  color: #ecf0f1;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-align: left;\n  border-bottom: 1px solid #2c3e50;\n}\n\n.section-button:hover {\n  background: #3c5a78;\n}\n\n.section-button.active {\n  background: #3498db;\n  color: white;\n}\n\n.admin-main {\n  flex: 1;\n  padding: 30px;\n}\n\n.config-section {\n  max-width: 600px;\n}\n\n.config-section h3 {\n  margin: 0 0 30px 0;\n  color: #2c3e50;\n  font-size: 24px;\n  border-bottom: 2px solid #3498db;\n  padding-bottom: 10px;\n}\n\n.config-group {\n  margin-bottom: 25px;\n}\n\n.config-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 600;\n  color: #2c3e50;\n  font-size: 14px;\n}\n\n.config-group input[type=\"number\"] {\n  width: 100%;\n  padding: 12px;\n  border: 2px solid #ddd;\n  border-radius: 6px;\n  font-size: 16px;\n  transition: border-color 0.2s ease;\n}\n\n.config-group input[type=\"number\"]:focus {\n  outline: none;\n  border-color: #3498db;\n}\n\n.checkbox-group {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.checkbox-group label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 0;\n  cursor: pointer;\n}\n\n.checkbox-group input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n}\n\n.config-help {\n  display: block;\n  margin-top: 5px;\n  font-size: 12px;\n  color: #7f8c8d;\n  font-style: italic;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .admin-panel {\n    padding: 10px;\n  }\n  \n  .admin-header {\n    flex-direction: column;\n    gap: 20px;\n    text-align: center;\n  }\n  \n  .admin-content {\n    flex-direction: column;\n  }\n  \n  .admin-sidebar {\n    width: 100%;\n    display: flex;\n    overflow-x: auto;\n  }\n  \n  .section-button {\n    white-space: nowrap;\n    min-width: 180px;\n  }\n  \n  .admin-main {\n    padding: 20px;\n  }\n  \n  .config-section {\n    max-width: 100%;\n  }\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.config-section {\n  animation: fadeIn 0.3s ease;\n}\n\n/* Custom number input styling */\n.config-group input[type=\"number\"]::-webkit-outer-spin-button,\n.config-group input[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.config-group input[type=\"number\"] {\n  -moz-appearance: textfield;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
